const popItembyIndex = (arr, index, newItem) => [
  newItem,
  ...arr.slice(0, index),
  ...arr.slice(index + 1),
];

export const deepCopy = (target) => {
  const copyed_objs = [];
  function _deepCopy(target) {
    if (typeof target !== 'object' || !target) {
      return target;
    }
    for (let i = 0; i < copyed_objs.length; i++) {
      if (copyed_objs[i].target === target) {
        return copyed_objs[i].copyTarget;
      }
    }
    let obj = {};
    if (Array.isArray(target)) {
      obj = [];
    }
    copyed_objs.push({ target, copyTarget: obj });
    Object.keys(target).forEach((key) => {
      if (obj[key]) {
        return;
      }
      obj[key] = _deepCopy(target[key]);
    });
    return obj;
  }
  return _deepCopy(target);
};
export const REQ_TYPE = {
  ADD_COMMENT: 'ADD_COMMENT',
  ADD_THREAD: 'ADD_THREAD',
  FETCH_LIST: 'FETCH_LIST',
  DEL_THREAD: 'DEL_THREAD',
  DEL_COMMENT: 'DEL_COMMENT',
  EDIT_THREAD: 'EDIT_THREAD',
  EDIT_COMMENT: 'EDIT_COMMENT',
};
const {
  ADD_COMMENT,
  ADD_THREAD,
  DEL_THREAD,
  DEL_COMMENT,
  EDIT_COMMENT,
  EDIT_THREAD,
} = REQ_TYPE;
export const findSameChannel = (arr = []) => {
  const channels = {};
  arr.forEach((item) => {
    if (!channels[`channel-${item.channel}`]) {
      channels[`channel-${item.channel}`] = [item];
    } else {
      channels[`channel-${item.channel}`].push(item);
    }
  });
  return channels;
};

export const formatComments = (channels) => {
  const res = [];
  Object.values(channels).forEach((item, i) => {
    res[i] = { comments: [] };
    item.forEach((itm, idx) => {
      if (itm.channel === itm.id) {
        res[i] = { ...itm, comments: res[i].comments };
        // res[i].comments.unshift(itm);
      } else {
        res[i].comments.push(itm);
      }
    });
  });
  res.forEach((i) => {
    if (Array.isArray(i.comments) && i.comments.length) {
      i.comments.sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      );
    }
  });
  return res;
};

export const formatData = (list) => {
  let res = [],
    channels = {};
  channels = findSameChannel(list);
  res = formatComments(channels);
  return res;
};

export const judgeAndReturnType = (commentData, type) => {
  let res = '';
  const id = commentData.id || commentData.commentId;
  switch (type) {
    case 'add':
      res = commentData.channel === id ? ADD_THREAD : ADD_COMMENT;
      break;
    case 'delete':
      res = commentData.channel === id || !id ? DEL_THREAD : DEL_COMMENT;
      break;
    case 'edit':
      res = commentData.channel === id || !id ? EDIT_THREAD : EDIT_COMMENT;
      break;
    default:
      break;
  }
  return res;
};

export const addDelComment = (originData, commentData, type) => {
  let d = deepCopy(originData);

  const threadIndex = d.findIndex(
    (thead) => thead.channel === commentData.channel,
  );

  if (typeof threadIndex === 'undefined') {
    return d;
  }

  const thread = d[threadIndex];
  let comments = thread.comments || [];

  if (type === ADD_COMMENT) {
    comments.push(commentData);
    // pop the newly comment thread;
    // d = [thread, ...d.slice(0, threadIndex), ...d.slice(threadIndex + 1)];
    d = popItembyIndex(d, threadIndex, thread);
  } else {
    // DELETE COMMENT by Id
    comments = comments.filter((c) => c.id !== commentData.commentId);
  }

  thread.comments = comments;
  return d;
};

export const addDelThread = (originData, commentData, type) => {
  const d = deepCopy(originData);
  if (type === ADD_THREAD) {
    d.unshift(commentData);
  } else {
    const idx = d.findIndex((item) => item.channel === commentData.channel);
    d.splice(idx, 1);
  }
  return d;
};

export const editThreadComment = (originData, commentData, type) => {
  let d = deepCopy(originData);
  d.forEach((item, idx) => {
    if (item.channel === commentData.channel) {
      if (type === EDIT_THREAD) {
        item = { ...item, ...commentData };
      } else {
        const id = commentData.commentId || commentData.id;
        const comments = item.comments;

        const idx = comments.findIndex((itm) => itm.id === id);
        comments[idx] = { ...item, ...commentData };
        item.comments = comments;
      }
      d = popItembyIndex(d, idx, item);
    }
    // return item;
  });
  return d;
};

export const COMMENT_LIST_TYPE = {
  SECTION: 'SECTION',
  MODULE: 'MODULE',
  ALL: 'ALL',
};

// export const componentTagModifier = (componentName = '') =>
//   componentName.replace(/anchorId\[.*\]/g, '');
